import { DropdownButton, Inline } from '@omnipresentgroup/design-system';
import { useState } from 'react';

import { RequestTerminationModal } from '../../employee-details';

export const EmployeeActionsCell = ({
  employeeId,
  permissions,
  handleRequestTermination,
}: {
  employeeId: string;
  permissions: Record<'canRequestTermination', boolean>;
  handleRequestTermination: () => void;
}) => {
  const [requestTerminationModalOpen, setRequestTerminationModalOpen] =
    useState(false);

  return (
    <>
      <Inline gap="8" justify="flex-end">
        <DropdownButton
          key={`employee-actions-${employeeId}`}
          variant="tertiary"
          icon="Dots"
          size="small"
          options={[
            ...(permissions.canRequestTermination
              ? [
                  {
                    name: 'Request termination',
                    onClick: () => setRequestTerminationModalOpen(true),
                  },
                ]
              : []),
          ]}
        />
      </Inline>

      {requestTerminationModalOpen && (
        <RequestTerminationModal
          key={`request-termination-${employeeId}`}
          modalProps={{
            open: requestTerminationModalOpen,
            onOpenChange: setRequestTerminationModalOpen,
          }}
          handleCancel={() => setRequestTerminationModalOpen(false)}
          handleConfirm={() => {
            setRequestTerminationModalOpen(false);
            handleRequestTermination();
          }}
        />
      )}
    </>
  );
};
